// Imports
import 'lazysizes';
import reframe from 'reframe.js';
import htmx from "htmx.org";

// Project imports
import Appear from '@js/modules/Appear';
import AppearGrid from '@js/modules/AppearGrid';
import AppearList from '@js/modules/AppearList';
import BackButtons from '@js/modules/BackButtons';
import Carousel from '@js/modules/Carousel';
import ExternalLinks from '@js/modules/ExternalLinks';
import FloorplansMap from '@js/modules/FloorplansMap';
import FloorplanDatePicker from '@js/modules/FloorplanDatePicker';
import Header from "@js/modules/Header";
import Modal from '@js/modules/Modal';
//import Navigation from '@js/modules/Navigation';
import Popup from '@js/modules/Popup';
import Slideover from '@js/modules/Slideover';
import Search from '@js/modules/Search';
import ScheduleTour from '@js/modules/ScheduleTour';

class Page {
    constructor() {
    }
    init() {
        // Appear animations
        Appear.init();
        AppearGrid.init();
        AppearList.init();

        // External links
        ExternalLinks.build();

        setTimeout(async () => {
            try {
                await window.FORMS.modules.Forms.destroyForms();

                setTimeout(async () => {
                    try {
                        await window.FORMS.modules.Forms.init();
                    } catch (error) {
                        console.error('Unable to initialize forms:', error);
                    }
                }, 200);
            } catch (error) {
                console.error('Unable to destroy forms:', error);
            }
        }, 200);

        /**
         * Header
         */
        Header.destroy();
        Header.init();

        /**
         * Back button
         */
        BackButtons.init();

        /**
         * Modal
         */
        Modal.init();

        /**
         * Floor Plans
         */
        setTimeout(() => {
            FloorplansMap.init();
        }, 100);

        /**
         * Search
         */
        Search.init();

        /**
         * Schedule a Tour
         */
        ScheduleTour.init(document);

        /**
         * Carousels
         */
        Carousel.initAll();

        /**
         * Slideover
         */
        Slideover.init();

        /**
         * Reframe
         */
        reframe('.reframe');

        /**
         * Line hover
         */
        const lineHoverEls = document.querySelectorAll('.link-hover');
        lineHoverEls.forEach((el, i) => {
            el.addEventListener('mouseover', () => {
                el.classList.add('_hover');
            });

            el.addEventListener('mouseout', () => {
                el.classList.remove('_hover');
            });
        });

        /**
         * To top button
         */
        const toTopBtns = document.querySelectorAll('.to-top');
        toTopBtns.forEach(btn => {
           btn.addEventListener('click', (e) => {
               window.scrollTo({
                   top: 0,
                   left: 0,
                   behavior: 'auto',
               });
           });
        });

        /**
         * Date picker
         */
        FloorplanDatePicker.init();
    }
}

export default new Page();
